import Navbar from '@/pages/home/components/Navbar';
import Hero from '@/pages/home/components/Hero';
import QuickStart from '@/pages/home/components/QuickStart';
import TagWall from '@/pages/home/components/TagWall';
import Tutorials from '@/pages/home/components/Tutorials';
import NewsDigest from '@/pages/home/components/NewsDigest';
import FaqSection from '@/pages/home/components/FaqSection';
import CommentWall from '@/pages/home/components/CommentWall';
import FeedbackPanel from '@/pages/home/components/FeedbackPanel';
import SiteFooter from '@/pages/home/components/SiteFooter';

export default function Home() {
  return (
    <div className="relative w-full min-h-screen bg-background-50">
      <Navbar />
      <main className="w-full">
        <Hero />
        <QuickStart />
        <TagWall />
        <Tutorials />
        <NewsDigest />
        <FaqSection />
        <CommentWall />
        <FeedbackPanel />
      </main>
      <SiteFooter />
    </div>
  );
}